const photoModules = import.meta.glob('./*.jpg', { eager: true, import: 'default' }) as Record<string, string>;

export const stodulkyImages: string[] = Object.entries(photoModules)
  .sort(([a], [b]) => a.localeCompare(b))
  .map(([, src]) => src);
